import { PaginationFooter } from '../audit/PaginationFooter';
import { DashboardsPage } from '../dashboards/DashboardsPage';
import { ListPageHeader } from '../shared/list-page/ListPageHeader';

import { isGiftPassFiltered } from './gift-passes-model';
import { GiftPassCompButton } from './GiftPassCompButton';
import { GiftPassesListToolbar } from './GiftPassesListToolbar';
import { GiftPassesResultsBody } from './GiftPassesResultsBody';
import { GiftPassesSummaryRow } from './GiftPassesSummaryRow';
import { PAGE_SIZE, useGiftPassListState } from './use-gift-pass-list-state';

import '../dashboards/dashboards.css';
import './gift-passes.css';

const RESULTS_CARD = {
  flex: 1,
  minHeight: 0,
  display: 'flex',
  flexDirection: 'column',
  padding: 0,
  overflow: 'hidden',
} as const;

export default function GiftPassesListPage() {
  const s = useGiftPassListState();
  // The empty state describes the query the results came from, not the box mid-typing.
  const filtered = isGiftPassFiltered({
    search: s.search,
    status: s.status,
    source: s.source,
  });

  return (
    <DashboardsPage
      header={
        <ListPageHeader
          crumb="Customers › Gift passes"
          title="Gift passes"
          actions={<GiftPassCompButton />}
        />
      }
    >
      <GiftPassesSummaryRow summary={s.summary} />
      <section className="nb-card nb-card-tight" style={RESULTS_CARD}>
        <GiftPassesListToolbar
          searchInput={s.searchInput}
          onSearchInputChange={s.setSearchInput}
          status={s.status}
          onStatusChange={s.setStatus}
          source={s.source}
          onSourceChange={s.setSource}
          onClear={s.clear}
          total={s.total}
        />
        <div style={{ flex: 1, minHeight: 0, overflow: 'auto' }}>
          <GiftPassesResultsBody
            rows={s.rows}
            loading={s.loading}
            error={s.error}
            search={s.search}
            filtered={filtered}
            order={s.order}
            onOrderChange={s.setOrder}
          />
        </div>
        {!s.error && !s.loading && s.rows.length > 0 && (
          <PaginationFooter
            offset={s.pager.offset}
            total={s.total}
            count={s.rows.length}
            currentPage={s.pager.currentPage}
            pageCount={s.pager.pageCount}
            hasPrev={s.pager.hasPrev}
            hasNext={s.pager.hasNext}
            onPrev={s.pager.prevPage}
            onNext={s.pager.nextPage}
            onPageSelect={(p) => s.pager.setOffset((p - 1) * PAGE_SIZE)}
          />
        )}
      </section>
    </DashboardsPage>
  );
}
